import { useForm } from "react-hook-form";
import { useState } from "react";

//components
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from 'primereact/dropdown';

//api
import { TemplateService } from "../../../../service/template-service";




const AddTemplate = ({ onTemplateCreated, onHide })=>{
    const { register, handleSubmit, setValue, formState: { errors } } = useForm(); 
    const [uploadSuccessMessage, setUploadSuccessMessage] = useState('');
    const [uploadErrorMessage, setUploadErrorMessage] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null)


    const status = [
        {name: 'active'},
        {name: 'archived'}
    ]

    const onFileChange = (event) => {
        if (event.files && event.files.length > 0) {
            setSelectedFile(event.files[0]);
            setUploadSuccessMessage(''); 
            setUploadErrorMessage('');
        } else {
            setSelectedFile(null);
        }
    };
    
    const onSubmit = (data)=>{
        if (!selectedFile) {
            console.error('Nessun file selezionato.');
            return;
        }
        const formData = new FormData();
        formData.append('name', data.name);
        formData.append('description', data.description);
        formData.append('file', selectedFile);
        formData.append('status', selectedStatus?.name || '')
        formData.append('destination_folder', data.destination_folder || '')

        TemplateService.postTemplate(
            formData,
            (response)=>{
                setUploadSuccessMessage('Template creato con successo!', response);
                setUploadErrorMessage('');
                // reset campi dopo caricamento file
                setSelectedFile(null)
                setValue('name', '');
                setValue('description', '');
                setValue('status', null);
                setValue('destination_folder', '');
                onTemplateCreated();
            },
            (error) => {
                console.error('Errore durante la creazione del template: ', error);
                setUploadErrorMessage('Errore durante la creazione del template.');
                setUploadSuccessMessage('');
              }
        )
    }
    return (
        <div style={{marginBottom:'2rem', marginRight:'2rem'}}>
            <form onSubmit={handleSubmit(onSubmit)}>
            {uploadSuccessMessage && <div className="p-message p-message-success" style={{ padding: '0.5em' }}>{uploadSuccessMessage}</div>}
            {uploadErrorMessage && <div className="p-message p-message-error" style={{ padding: '0.5em' }}>{uploadErrorMessage}</div>}
                <div className="p-field addAnalysisFile__InputWrapper">
                    <label htmlFor="name">Nome Template*</label>
                    <InputText id="name" {...register('name', { required: 'Campo obbligatorio' })} className={errors.name ? 'p-invalid' : ''} />
                    {errors.name && <small className="p-error">{errors.name.message}</small>}
                </div>
                <div className="template__DropdownWrapper" style={{justifyContent: "space-between"}}>
                    <div className="card template__DropdownInput" style={{width: '15rem'}}>
                        <label htmlFor="name" >Stato</label>
                            <Dropdown value={selectedStatus} onChange={(e) => setSelectedStatus(e.value)} options={status} optionLabel="name" 
                                placeholder="Seleziona uno Status" className="w-full md:w-14rem" style={{margin:'0.5rem 0'}}/>
                    </div>
                    <div className="card template__DropdownInput" style={{width: '15rem'}}>
                        <label htmlFor="destination_folder">Cartella di destinazione</label>
                        <InputText id="destination_folder" {...register('destination_folder')}  />
                        
                    </div>
                </div>
                <div className="p-field addAnalysisFile__InputWrapper">
                    <label htmlFor="description">Descrizione</label>
                    <InputTextarea id="description" {...register('description')} rows={3} cols={30} />
                </div>

                <div className="p-field ">
                    <label htmlFor="file">Upload Cartella</label>
                    <FileUpload
                        id="file"
                        name="file"
                        maxFileSize={1000000}
                        onSelect={onFileChange}
                        mode="basic"
                        chooseLabel="Scegli Cartella .zip"
                        accept=".zip"
                        style={{marginTop:'0.5rem'}}
                    />
                    {selectedFile && <small>File selezionato: {selectedFile.name}</small>}
                    {selectedFile === null && <small className="p-error">Seleziona una cartella .zip.</small>}
                </div>
                <Button label="Salva" type="submit" disabled={!selectedFile || Object.keys(errors).length > 0} style={{marginTop:'1rem'}}/>
            </form>
        </div>
    );
}

export default AddTemplate